/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonskindwebsite3Inputs */

const en_listingbuttonskindwebsite3 = /** @type {(inputs: Listingbuttonskindwebsite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

const de_listingbuttonskindwebsite3 = /** @type {(inputs: Listingbuttonskindwebsite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Listingbuttonskindwebsite3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonskindwebsite3 = /** @type {((inputs?: Listingbuttonskindwebsite3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonskindwebsite3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonskindwebsite3(inputs)
	return de_listingbuttonskindwebsite3(inputs)
});
export { listingbuttonskindwebsite3 as "listingButtonsKindWebsite" }